import { WaterValve } from '../../../_unit-operations/utilties/water-valve';
import { SimulationVariable } from '../../../simulation-variable';
import { SimulationVariableName } from '../../../../_config/simulation-variable-name.enum';
import { ConstraintReportVariable } from '../constraint-report-variable';

export class WaterValveConstraintReportVariableResolver {
  static create() {
    return new WaterValveConstraintReportVariableResolver();
  }

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  private constructor() {}

  addCurrentValueAndUnitToConstraintReportVariable(
    crv: ConstraintReportVariable,
    params: { uo: WaterValve; simVar: SimulationVariable }
  ): void {
    const { uo, simVar } = params;

    const inletStreamList = uo.ownerCase.filterWaterMaterialStreams(s => {
      return s.outletUnitOperationId === uo.id;
    });

    if (!inletStreamList.length) {
      return;
    }

    if (simVar.name === SimulationVariableName.MAXIMUM_FEED_CAPACITY) {
      crv.currentValue = inletStreamList[0].massFlowrate.convertToDefaultUnit(true, false);
      crv.currentUnit = inletStreamList[0].massFlowrate.getDefaultUnit();
      return;
    }

    throw new Error(`Unknown constraint: ${simVar.name}`);
  }
}
